module.exports = __webpack_public_path__ + "img/trinapps_fam.7a1ff471.png";